<!-- Modale tabella quotazioni -->
<div
  class="modal fade main-font"
  id="spModal"
  tabindex="-1"
  aria-labelledby="spModalLabel"
  aria-hidden="true">
  <div
    class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    [ngClass]="{ 'modal-sm': isMobileMode == true }">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="secondary-color mb-0">Scala Story Point</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="form">
          <div class="row">
            <div class="col text-center">
              <label class="labels">Incertezza</label>&nbsp;<i
                class="fas fa-info-circle info"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"></i>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Incertezza</th>
                      <th scope="col">Ore</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Small</th>
                      <td><= 4</td>
                    </tr>
                    <tr>
                      <th scope="row">Medium</th>
                      <td>>= 5 & <= 16</td>
                    </tr>
                    <tr>
                      <th scope="row">Large</th>
                      <td colspan="2">> 16</td>
                    </tr>
                  </tbody>
                </table>
              </ul>
            </div>
            <div class="col text-center">
              <label class="labels">Complessità</label>
            </div>
            <div class="col text-center dropstart">
              <label class="labels">Effort</label>&nbsp;<i
                class="fas fa-info-circle info"
                id="dropdownMenuButton2"
                data-bs-toggle="dropdown"
                aria-expanded="false"></i>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                <table class="table" style="width: 211px">
                  <thead>
                    <tr>
                      <th scope="col">Effort</th>
                      <th scope="col">Ore</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Small</th>
                      <td><= 8</td>
                    </tr>
                    <tr>
                      <th scope="row">Medium</th>
                      <td>> 8 & <= 24</td>
                    </tr>
                    <tr>
                      <th scope="row">Large</th>
                      <td colspan="2">> 24 & <= 40</td>
                    </tr>
                  </tbody>
                </table>
              </ul>
            </div>
          </div>
          <br />
          <!-- Input per le ore di incertezza ed sforzo -->
          <div class="row">
            <div class="col-4 text-center">
              <mat-form-field class="col-12">
                <mat-label>Ore</mat-label>
                <input
                  type="number"
                  min="1"
                  matInput
                  formControlName="search_hours_uncertainty"
                  (input)="onHoursInput('uncertainty', $event)" />
              </mat-form-field>
            </div>
            <!-- bottone calcola complessità -->
            <div class="col-4 text-center d-flex justify-content-center">
              <button
                mat-button
                class="custom-calculate-button"
                (click)="toggleComplexity()">
                <span class="custom-icon">
                  <img
                    src="../../../../../assets/images/calculator.svg"
                    alt="" />
                </span>
              </button>
            </div>
            <div class="col-4 text-center">
              <mat-form-field class="col-12">
                <mat-label>Ore</mat-label>
                <input
                  type="number"
                  min="1"
                  matInput
                  formControlName="search_hours_effort"
                  (input)="onHoursInput('effort', $event)" />
              </mat-form-field>
            </div>
          </div>
        </form>

        <!-- Calcola Complessità -->
        <div class="row">
          <!-- frontend -->
          <div class="col-12" *ngIf="showCalculateComplexity">
            <hr />
            <div class="row padding-t">
              <div class="col-6">
                <div class="text-center">
                  <mat-select
                    class="form-control"
                    placeholder="Argomenti Frontend"
                    (selectionChange)="
                      onSelectionChangeCaomplexity($event, 'fe')
                    "
                    [multiple]="false">
                    <mat-option
                      *ngFor="let feArg of argumentsFrontend"
                      [value]="feArg.id">
                      {{ feArg.alias }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>

              <div class="col-6">
                <div class="text-center">
                  <nz-select
                    class="form-control"
                    nzMode="multiple"
                    nzPlaceHolder="Micro argomenti"
                    [(ngModel)]="selectedMicroArgFe"
                    [nzAllowClear]="true"
                    [nzShowSearch]="true"
                    [nzDisabled]="!selectedFrontendArgs"
                    (ngModelChange)="
                      onSelectionChangeCaomplexity($event, 'microFe')
                    "
                    [nzMaxTagCount]="0">
                    <nz-option
                      *ngFor="let micro of microArgFe"
                      [nzValue]="micro"
                      [nzLabel]="micro.alias">
                    </nz-option>
                  </nz-select>
                </div>
              </div>

              <!-- Riepilogo con Chips FE -->
              <div *ngIf="selectedMicroFeChips" class="col-12 text-center">
                <div class="chips-container">
                  <mat-chip-listbox>
                    <mat-chip
                      *ngFor="let chip of selectedMicroFeChips"
                      [removable]="true"
                      (removed)="removeChip(chip, 'microFe')"
                      matTooltip="{{ chip.alias ?? '' }}"
                      matTooltipPosition="above">
                      {{ chip.alias ?? '' | slice: 0 : 22
                      }}<ng-container *ngIf="(chip.alias?.length ?? 0) > 15"
                        >...</ng-container
                      >
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </mat-chip-listbox>
                </div>
              </div>
            </div>

            <!-- backend -->
            <div class="row">
              <div class="col-6">
                <div class="text-center">
                  <mat-select
                    class="form-control"
                    placeholder="Argomenti backend"
                    (selectionChange)="
                      onSelectionChangeCaomplexity($event, 'be')
                    "
                    [multiple]="false">
                    <mat-option
                      *ngFor="let feArg of argumentsBackend"
                      [value]="feArg.id">
                      {{ feArg.alias }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>

              <div class="col-6">
                <div class="text-center">
                  <nz-select
                    class="form-control"
                    nzMode="multiple"
                    nzPlaceHolder="Micro argomenti"
                    [(ngModel)]="selectedMicroArgBe"
                    [nzAllowClear]="true"
                    [nzShowSearch]="true"
                    [disabled]="!selectedBackend"
                    (ngModelChange)="
                      onSelectionChangeCaomplexity($event, 'microBe')
                    "
                    [nzMaxTagCount]="0">
                    <nz-option
                      *ngFor="let micro of microArgBe"
                      [nzValue]="micro"
                      [nzLabel]="micro.alias">
                    </nz-option>
                  </nz-select>
                </div>
              </div>

              <!-- Riepilogo con Chips BE -->
              <div *ngIf="selectedMicroBeChips" class="col-12 text-center">
                <div class="chips-container">
                  <mat-chip-listbox>
                    <mat-chip
                      *ngFor="let chip of selectedMicroBeChips"
                      [removable]="true"
                      (removed)="removeChip(chip, 'microBe')"
                      matTooltip="{{ chip.alias ?? '' }}"
                      matTooltipPosition="above">
                      {{ chip.alias ?? '' | slice: 0 : 15
                      }}<ng-container *ngIf="(chip.alias?.length ?? 0) > 15"
                        >...</ng-container
                      >
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </mat-chip-listbox>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>

        <form [formGroup]="form">
          <!-- Selezione multipla per Incertezza, Complessità ed Effort -->
          <div class="row">
            <div class="col-4 text-center">
              <mat-select
                [multiple]="true"
                class="col-3 form-control"
                id="selected_uncertainty"
                placeholder="Incertezza"
                formControlName="selected_uncertainty"
                (selectionChange)="addToArr('selected_uncertainty')">
                <mat-option
                  (click)="onSelectionChange()"
                  *ngFor="let category of incertezza_quotes"
                  [value]="category.id">
                  <ng-container *ngIf="isMobileMode; else alias">{{
                    category.short_alias
                  }}</ng-container>
                  <ng-template #alias>{{ category.alias }}</ng-template>
                </mat-option>
              </mat-select>
            </div>
            <div class="col-4 text-center">
              <mat-select
                [multiple]="true"
                class="col-3 form-control"
                id="selected_complexity"
                placeholder="Complessità"
                formControlName="selected_complexity"
                (selectionChange)="addToArr('selected_complexity')">
                <mat-option
                  (click)="fetchStoryPoints(); this.resetClicked = true"
                  *ngFor="let category of complessita_quotes"
                  [value]="category.id">
                  <ng-container *ngIf="isMobileMode; else alias">{{
                    category.short_alias
                  }}</ng-container>
                  <ng-template #alias>{{ category.alias }}</ng-template>
                </mat-option>
              </mat-select>
            </div>
            <div class="col-4 text-center">
              <mat-select
                [multiple]="true"
                class="col-3 form-control"
                id="selected_effort"
                placeholder="Effort"
                formControlName="selected_effort"
                (selectionChange)="addToArr('selected_effort')">
                <mat-option
                  (click)="onSelectionChangeEffort()"
                  *ngFor="let category of effort_quotes"
                  [value]="category.id">
                  <ng-container *ngIf="isMobileMode; else alias">{{
                    category.short_alias
                  }}</ng-container>
                  <ng-template #alias>{{ category.alias }}</ng-template>
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="search-bar col-11 float-end mt-4 mb-4">
              <input
                type="text"
                class="w-100 px-2"
                formControlName="search_quotes"
                placeholder="Cerca per quotazione"
                name="search_quotes"
                (keypress)="validateInput($event)"
                (input)="onInputChange($event)"
                maxlength="3" />
            </div>
            <div class="col-1">
              <button
                type="button"
                zn-button
                class="w-100 delete-btn"
                [ngClass]="{
                  'opacity-50': !hasData(),
                  'cursor-pointer': hasData()
                }"
                (click)="resetAllSelections()"
                [disabled]="!hasData()"
                [nz-tooltip]="hasData() ? 'Ripristina filtri' : ''">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <p
            *ngIf="
              inputLength < 3 &&
              form.get('search_quotes')?.touched &&
              inputLength > 0
            "
            class="text-danger">
            Devi digitare almeno tre caratteri.
          </p>
          <!-- End Search bar -->
        </form>
        <!-- Tabella -->
        <div
          class="container-fluid table-responsive"
          style="max-height: 400px; overflow-y: auto">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col" class="text-center">Incertezza</th>
                <th scope="col" class="text-center">Complessità</th>
                <th scope="col" class="text-center">Effort</th>
                <th scope="col" class="text-center">SP</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="(storyPoints?.length ?? 0) > 0; else noResults">
                <tr *ngFor="let storypoint of storyPoints">
                  <td class="text-center">{{ storypoint.uncertainty }}</td>
                  <td class="text-center">{{ storypoint.complexity }}</td>
                  <td class="text-center">{{ storypoint.effort }}</td>
                  <td class="text-center">{{ storypoint.value_storypoint }}</td>
                </tr>
              </ng-container>
              <ng-template #noResults>
                <tr>
                  <td colspan="4" class="text-center">
                    Nessun risultato trovato
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <!-- End Tabella -->
      </div>
      <div class="modal-footer d-flex align-items-center">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="resetAllSelections()">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
<!-- End Modale -->
